/*!
 * Group items from an array together by some criteria or value.
 * Adapted from... (c) 2019 Tom Bremmer (https://tbremer.com/) and Chris Ferdinandi (https://gomakethings.com), MIT License,
 * @param  {Array}           arr      The array to group items from
 * @param  {String|Function} criteria The criteria to group by
 * @return {Map}                      The grouped mapping
 */

// eslint-disable-next-line
Array.prototype.groupBy = function(criteria) {
  const map = new Map();
  this.forEach(item => {
    var key = typeof criteria === 'function' ? criteria(item) : item[criteria];

    // if the key doesn't exist yet, create it
    if (!map.has(key)) {
      map.set(key, []);
    }

    // Push the value to the object
    map.get(key).push(item);
  });
  return map;
};

// eslint-disable-next-line
Array.prototype.equals = function(otherArr) {
  if (!Array.isArray(otherArr)) return false;
  return (
    this.length === otherArr.length &&
    this.every(function(element, index) {
      return element === otherArr[index];
    })
  );
};
